import type { Action } from '@reduxjs/toolkit'
import type { Observable } from 'rxjs'
import type { TActions, TRepositories } from '../../index.ts'
import type { State } from '../../Slice/index.ts'
import type { DraftState } from '../../../Model/OrderWizard/OrderWizardDraft.ts'
import type { WizardRepositories } from '../../../Services/OrderWizard/repository/index.ts'

export type RootState = typeof State

export const draftOf = (state: RootState, draftId: string): DraftState | undefined => state.orderWizard.drafts[draftId]

export type WizardDependencies = TRepositories & TActions & WizardRepositories

/** An epic of the wizard: the app's repositories plus the wizard's own. */
export type WizardEpic = (action$: Observable<Action>, state$: Observable<RootState>, dependencies: WizardDependencies) => Observable<Action>
